import React, {useState} from 'react'
import {Collapse} from 'react-collapse'
import './Faq.scss'

const Question = ({question, answer, icon}) => {
	const [isOpen, setIsOpen] = useState(false)

	return(
		<div className="FaqQuestion">
			<button className={isOpen ? 'question active' : 'question'} aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)}>
				<span className={icon} dangerouslySetInnerHTML={{__html: question}} />
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
					<g transform="translate(-970.242 722.299) rotate(-45)">
						<rect width="12" height="2" transform="translate(1191.857 187.343) rotate(-45)" />
						<rect width="12" height="2" transform="translate(1193.272 178.858) rotate(45)" />
					</g>
				</svg>
			</button>
			<Collapse isOpened={isOpen}>
				{
					isOpen &&
					<div aria-hidden={!isOpen} className="answer" dangerouslySetInnerHTML={{__html: answer}} />
				}
			</Collapse>
		</div>
	)
}

export default function Faq({questions, id, faqType}) {
	return(
		<div className={`Faq ${faqType}`}>
			{
				questions.map((question, i) => <Question key={`${id}_${i}`} {...question} />)
			}
		</div>
	)
}